import React, { useEffect, useRef, useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import { useSelector } from 'react-redux';
import { REVREX_APP_BASE_URL, URLS } from '../../resources/constants';
import { getAccountSettings, getIsQbdImport, getMonthClosedBetweenDepositAndSalesMismatch, getSettings, getThirdPartyImportedStep, getThirdPartyStepsCompleted } from '../../store/settings/selectors';
import { getHelperPermissions, getLoginType, getUser } from '../../store/user/selectors';
// import { getFirstLoginStatus } from '../../store/settings/selectors'
import ChartAccountModal from '../../components/Modal/ChartOfAccount/ChartAccountModal';
import { useSettingsApi } from '../../resources/hooks/api/useSettingsApiHook';
//import { useUserDataApi } from '../../resources/hooks/api/userDataApiHook'
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { canViewSection, hasPermission } from '../../resources/functions';

import exitStrategyIcon from '../../assets/images/exit-strategy-icon-w.svg';
import expenseClassificationIcon from '../../assets/images/expense-classification-icon-w.svg';
import reportIcon from '../../assets/images/report-icon-w.svg';
import revenueReconciliationIcon from '../../assets/images/revenue-reconciliation-icon-w.svg';
import RevrexSyncGLAcc from '../../components/Modal/RevrexSyncGLAcc/RevrexSyncGLAcc';
import QBValidationReportModal from '../../components/Modal/QBValidationReport/QBValidationReportModal';

import SAlert from 'components/SAlert';
import toast from 'react-hot-toast';
import { getBranch } from '../../store/user/selectors';
import BalanceSheetRefreshStatus from '../ThirdParty/QuickBook/BalanceSheetRefreshStatus';
import { useGlClassificationApi } from 'resources/hooks/api/glClassificationApi';


interface Props {

}

type ConfigurationStepStatus = 'completed' | 'active' | 'pending' | 'locked';
type SetupMethodSelection = 'manual' | 'erp' | null;
type ConfigurationStep = {
    key: 'coa' | 'beginning-balance' | 'deposit-classification' | 'expense-classification' | 'revenue-classification';
    stepNumber: number;
    title: string;
    status: ConfigurationStepStatus;
    to: string;
};

const Dashboard: React.FC<Props> = () => {
    //   const _records = useSelector(getTableDataRecords)
    //   const _users = useSelector(getUser)
    // const _getOpeningBalanceExistsSettings = useSelector(getOpeningBalanceExistsSettings);
    const _getAccountSettings = useSelector(getAccountSettings);
    const _getThirdPartyStepsCompletedRaw = useSelector(getThirdPartyStepsCompleted);
    
    const _getThirdPartyImportedStep = useSelector(getThirdPartyImportedStep);
    const _getIsQbdImport = useSelector(getIsQbdImport);
    const _getThirdPartyStepsCompleted = _getIsQbdImport ? 0 : _getThirdPartyStepsCompletedRaw;
    const userData = useSelector(getUser)
    const _getMonthClosedBetweenDepositAndSalesMismatch = useSelector(getMonthClosedBetweenDepositAndSalesMismatch);
    const helperPermissions = useSelector(getHelperPermissions);
    const loginType = useSelector(getLoginType);
    const { t } = useTranslation("scenes.dashboard");
    const { t: tNav } = useTranslation("Tax1099Nav");
    const navigate = useNavigate();
    // Check if user is a helper
    const isHelper = loginType === 'helper';

    // Permission checks for dashboard sections
    const canViewClassification = canViewSection(helperPermissions, 'classification');
    const canViewMaintenance = canViewSection(helperPermissions, 'maintenance');
    const canViewForms = canViewSection(helperPermissions, 'forms');
    const canViewReports = canViewSection(helperPermissions, 'reports');
    const canViewTaxResolution = canViewSection(helperPermissions, 'taxResolution');

    // const { userAllowance, userStepStatus } = useUserApi();
    const { fetchAccountSettingsData, upgradeToLatestGL } = useSettingsApi();
    // const { dashboardRatioData } = useReportApi();
    // const _userSteps = useSelector(getFirstLoginStatus);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showCOAModal, setShowCOAModal] = useState<boolean>(false)
    const [createNewAccount, setCreateNewAccount] = useState<boolean>(false);
    // const [confirmationToLatest, setConfirmationToLatest] = useState<boolean>(false);
    // const [dashboardRatio, setDashboardRatio] = useState<any | null>(null);
    const [modalSyncGl, setModalSyncGl] = useState<any>({
        syncBankAcc: false,
        syncSalesAcc: false
    });
    const [showQBOAlert, setShowQBOAlert] = useState<boolean>(false);
    const [showPosMismatchClosedMonthDepositSalesAlert, setShowPosMismatchClosedMonthDepositSalesAlert] = useState<boolean>(false);
    const [setupSelection, setSetupSelection] = useState<{ branchId: number; method: SetupMethodSelection } | null>(null);
    const [isOpenValidationModal, setIsOpenValidationModal] = useState<boolean>(false);
    const [settingsErrorBranch, setSettingsErrorBranch] = useState<number | null>(null);
    const settingsRequest = useRef(0);

    const branchData = useSelector(getBranch)
    const branchId = Number(branchData?.id);
    const settingsMatchBranch = (branchId > 0) && (Number(_getAccountSettings.location_branch_id) === branchId);
    const selectedSetupMethod = setupSelection?.branchId === branchId ? setupSelection.method : null;
    const setSelectedSetupMethod = (method: SetupMethodSelection) => setSetupSelection({ branchId, method });
    const _getSettings = useSelector(getSettings);
    const { completeStep } = useGlClassificationApi();
    const _qbdKeyStatus = _getSettings.qbd_key_status;
    useEffect(() => {
        // fetchAccMapping();
        if (branchId > 0) {
            getSettingsData();

            const isERPOptionAvailable = [2, 3].includes(_getAccountSettings.accounting_type);
            const reconnectOrigin = localStorage.getItem('qbo_reconnect_origin');
            if (reconnectOrigin) {
                if (isERPOptionAvailable && (reconnectOrigin === 'dashboard_validation')) {
                    setIsOpenValidationModal(true);
                }
                localStorage.removeItem('qbo_reconnect_origin');
            }
        }
        // fetchUserSteps();
        // getDashboardRatioData();
        return () => { settingsRequest.current += 1; };
    }, [branchId, _getAccountSettings.accounting_type])

    useEffect(() => {
            if (!settingsMatchBranch) return;
            if ([1, 2, 3, 4].includes(_getThirdPartyStepsCompleted)) {
                navigate(URLS.THIRD_PARTY);
            }

            // setShowQBOAlert(_getThirdPartyStepsCompleted >= 3 && _getAccountSettings.bank_account_count == 0);

            console.log('1. _getMonthClosedBetweenDepositAndSalesMismatch: ', _getMonthClosedBetweenDepositAndSalesMismatch)
            if (_getMonthClosedBetweenDepositAndSalesMismatch && (_getAccountSettings.is_beginning_balance_exists == 1) && (_getAccountSettings.is_coa_modified == 1) && ((_getThirdPartyStepsCompleted === 0) || (_getThirdPartyStepsCompleted >= 5))) {
                console.log('2. _getMonthClosedBetweenDepositAndSalesMismatch: ', _getMonthClosedBetweenDepositAndSalesMismatch)
                setShowPosMismatchClosedMonthDepositSalesAlert(true);
            } else {
                console.log('3. _getMonthClosedBetweenDepositAndSalesMismatch: ', _getMonthClosedBetweenDepositAndSalesMismatch)
                setShowPosMismatchClosedMonthDepositSalesAlert(false);
            }
    }, [settingsMatchBranch, _getThirdPartyStepsCompleted, _getAccountSettings, _getMonthClosedBetweenDepositAndSalesMismatch])

    const getSettingsData = () => {
        if (!branchData?.id) return;
        const requestId = ++settingsRequest.current;
        setSettingsErrorBranch(null);
        fetchAccountSettingsData({ branch_id: +branchData['id'] }, (msg: string, resp: any) => {
            if (requestId === settingsRequest.current) setSettingsErrorBranch(null);
        }, (msg: string, resp: any) => {
            if (requestId === settingsRequest.current) setSettingsErrorBranch(branchId);
        })
    }

    const upsertCOA = (addNew: boolean) => {
        setCreateNewAccount(addNew);
        setShowCOAModal(true);
    }

    const hideCOAModal = () => {
        setShowCOAModal(false);
    }

    const updateSyncGlModal = (params: any) => {
        setModalSyncGl((prevState: any) => {
            return {
                ...prevState,
                ...params
            }
        })
    }

    const confirmUpdationToLatest = () => {
        setIsLoading(true);
        upgradeToLatestGL({ branch_id: +branchData['id'] }, (msg: string, resp: any) => {
            setIsLoading(false);
            toast.success(resp?.data?.message || msg);
        }, (msg: string, resp: any) => {
            setIsLoading(false);
            toast.error(resp?.data?.message || msg);
        })
    }

    const closeSyncModal = () => {
        setModalSyncGl({
            syncBankAcc: false,
            syncSalesAcc: false
        })
        getSettingsData();
    }

    const isCOACompleted = _getAccountSettings.is_coa_modified == 1;
    const isBeginningBalanceCompleted = _getAccountSettings.is_beginning_balance_exists == 1;
    const isClassificationFlowUnlocked = isCOACompleted && isBeginningBalanceCompleted && ((_getThirdPartyStepsCompleted == 0) || (_getThirdPartyStepsCompleted > 2));
    const transactionActivityStatus = _getAccountSettings.transaction_activity_status;
    const isManualOptionAvailable = [1, 3].includes(_getAccountSettings.accounting_type);
    const isERPOptionAvailable = [2, 3].includes(_getAccountSettings.accounting_type);

    const isManualSetupStarted = _getIsQbdImport || isCOACompleted || isBeginningBalanceCompleted || isClassificationFlowUnlocked;
    const isERPSetupStarted = _getAccountSettings.erp_in_use || (_getThirdPartyStepsCompleted > 0);
    const isERPSetupCompleted = _getThirdPartyStepsCompleted >= 5;
    const shouldShowSetupMethodSelection = isManualOptionAvailable && isERPOptionAvailable && !isManualSetupStarted && !isERPSetupStarted && !selectedSetupMethod;
    const shouldShowManualConfiguration = isManualOptionAvailable && (!isERPSetupStarted || isERPSetupCompleted) && (isManualSetupStarted || (selectedSetupMethod === 'manual') || !isERPOptionAvailable);
    const shouldShowERPSection = isERPOptionAvailable && !isERPSetupCompleted && (isERPSetupStarted || (selectedSetupMethod === 'erp') || !isManualOptionAvailable);
    const shouldShowSetupMethodBackButton = !!selectedSetupMethod && !isManualSetupStarted && !isERPSetupStarted;

    useEffect(() => {
        if (!settingsMatchBranch) return;
        if (isERPSetupStarted && !isERPSetupCompleted) {
            setSelectedSetupMethod('erp');
        } else if (isManualSetupStarted) {
            setSelectedSetupMethod('manual');
        }
    }, [branchId, settingsMatchBranch, isERPSetupStarted, isERPSetupCompleted, isManualSetupStarted]);

    const getStepPresentation = (status: ConfigurationStepStatus) => {
        switch (status) {
            case 'completed':
                return t('dashboard.step.status.completed');
            case 'active':
                return t('dashboard.step.status.active');
            default:
                return t('dashboard.step.status.pending');
        }
    }

    const configurationStepsForManual: ConfigurationStep[] = [
        {
            key: 'coa',
            stepNumber: 1,
            title: t('dashboard.step_1.title'),
            status: (isCOACompleted ? 'completed' : 'active') as ConfigurationStepStatus,
            
            to: (!isCOACompleted && _getIsQbdImport && (_getThirdPartyImportedStep > 0))
                ? URLS.QUICKBOOK_COA
                : URLS.CHARTACCOUNT
        },
        {
            key: 'beginning-balance',
            stepNumber: 2,
            title: t('dashboard.step_2.title'),
            status: (!isCOACompleted ? 'locked' : isBeginningBalanceCompleted ? 'completed' : 'active') as ConfigurationStepStatus,
            to: isCOACompleted ? ((_getThirdPartyStepsCompleted == 0) ? URLS.OPENNING_BALANCE : URLS.THIRD_PARTY) : ''
        },
        {
            key: 'deposit-classification',
            stepNumber: 3,
            title: t('dashboard.step_3.title'),
            status: (!isClassificationFlowUnlocked ? 'locked' : transactionActivityStatus === 0 ? 'active' : transactionActivityStatus > 0 ? 'completed' : 'pending') as ConfigurationStepStatus,
            to: isClassificationFlowUnlocked ? URLS.DEPOSIT_GL_CLASSIFICATION_STATUS : ''
        },
        {
            key: 'expense-classification',
            stepNumber: 4,
            title: t('dashboard.step_4.title'),
            status: (!isClassificationFlowUnlocked ? 'locked' : transactionActivityStatus === 1 ? 'active' : transactionActivityStatus > 1 ? 'completed' : 'pending') as ConfigurationStepStatus,
            to: isClassificationFlowUnlocked && (transactionActivityStatus >= 1) ? URLS.EXPENSE_GL_CLASSIFICATION_STATUS : ''
        },
        {
            key: 'revenue-classification',
            stepNumber: 5,
            title: t('dashboard.step_5.title'),
            status: (!isClassificationFlowUnlocked ? 'locked' : transactionActivityStatus === 2 ? 'active' : transactionActivityStatus > 2 ? 'completed' : 'pending') as ConfigurationStepStatus,
            to: isClassificationFlowUnlocked && (transactionActivityStatus >= 2) ? URLS.REVENUE_GL_CLASSIFICATION_STATUS : ''
        }
    ];
     const configurationStepsForQBD: ConfigurationStep[]= [
        {
            key: 'coa',
            stepNumber: 1,
            title: t('dashboard.step_1.title'),
            status: (isCOACompleted ? 'completed' : 'active') as ConfigurationStepStatus,
            
            to: (!isCOACompleted && _getIsQbdImport && _getThirdPartyImportedStep > 0)
                ? URLS.QUICKBOOK_COA
                : URLS.CHARTACCOUNT
        },
        {
            key: 'beginning-balance',
            stepNumber: 2,
            title: t('dashboard.step_2.title'),
            status: (!isCOACompleted ? 'locked' : isBeginningBalanceCompleted ? 'completed' : 'active') as ConfigurationStepStatus,
            to: isCOACompleted ? ((_getThirdPartyStepsCompleted == 0) ? URLS.OPENNING_BALANCE : URLS.THIRD_PARTY) : ''
        },
        
    ];

    const configurationSteps=_qbdKeyStatus==='active'?configurationStepsForQBD:configurationStepsForManual;
    const isQBDCompleted = _qbdKeyStatus === 'active' && isCOACompleted && isBeginningBalanceCompleted;

    const navigateToConfigurationStep = (step?: ConfigurationStep) => {
        if (!step?.to) {
            return;
        }

        navigate(step.to);
    }

    const skipAllSteps = async () => {
        setIsLoading(true);

        const runStep = (params: any) =>
            new Promise<void>((resolve, reject) => {
                completeStep(
                    params,
                    () => resolve(),
                    (errMsg: string) => reject(errMsg)
                );
            });

        // QBD only requires Step 1 (type 1) and Step 2 (type 2, step 1)
        // Manual requires all classification steps (type 1, and type 2 steps 1, 2, 3)
        const steps = _qbdKeyStatus === 'active'
            ? [
                ...(!isCOACompleted ? [{ branch_id: branchId, type: 1 }] : []),
                ...(!isBeginningBalanceCompleted ? [{ branch_id: branchId, type: 2, step: 1 }] : []),
                // Complete remaining classifications in the background if required by the backend
                { branch_id: branchId, type: 2, step: 2 },
                { branch_id: branchId, type: 2, step: 3 },
            ]
            : [
                { branch_id: branchId, type: 1 },
                { branch_id: branchId, type: 2, step: 1 },
                { branch_id: branchId, type: 2, step: 2 },
                { branch_id: branchId, type: 2, step: 3 },
            ];

        try {
            for (const stepPayload of steps) {
                await runStep(stepPayload);
                await new Promise((r) => setTimeout(r, 60));
            }
            setIsLoading(false);
            window.location.reload();
        } catch (error: any) {
            setIsLoading(false);
            toast.error(typeof error === 'string' ? error : 'Failed to complete steps');
        }
    };

    const renderConfigurationStepper = (linkClassName = '') => (
        <div className={`steps-panel-wrapper gl-config-steps-wrapper `}>
            <ul className="steps-panel gl-config-steps-panel gl-config-steps-panel-qbd ">
                {configurationSteps.map((step) => {
                    const isLinkEnabled = !!step.to;
                    const content = (
                        <>
                            <div className="step-kicker">{t('dashboard.step.label')} {step.stepNumber}</div>
                            <div className="step-indicator" aria-hidden="true"></div>
                            <h4>{step.title}</h4>
                            <p className="step-status">{getStepPresentation(step.status)}</p>
                        </>
                    );

                    return (
                        <li key={step.key} className={`step-block gl-config-step ${step.status}`}>
                            <div className='step-block-inner'>
                                {isLinkEnabled ? (
                                    <Link
                                        to={step.to}
                                        className={`steps-panel-a gl-config-step-link ${linkClassName}`.trim()}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            navigateToConfigurationStep(step);
                                        }}
                                    >
                                        {content}
                                    </Link>
                                ) : (
                                    <div className={`steps-panel-a gl-config-step-link ${linkClassName}`.trim()}>
                                        {content}
                                    </div>
                                )}
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    )

const currentConfigurationStep = configurationSteps.find((step) => step.status === 'active')
    || configurationSteps.find((step) => step.to && step.status !== 'completed');

    const getConfigurationButtonLabel = () => {
        if (!currentConfigurationStep) {
            return t('dashboard.configuration.btn_default');
        }

        switch (currentConfigurationStep.key) {
            case 'coa':
                return t('dashboard.configuration.btn_start');
            case 'beginning-balance':
                return t('dashboard.configuration.btn_beginning_balance');
            case 'deposit-classification':
                return t('dashboard.configuration.btn_deposit_classification');
            case 'expense-classification':
                return t('dashboard.configuration.btn_expense_classification');
            case 'revenue-classification':
                return t('dashboard.configuration.btn_revenue_classification');
            default:
                return t('dashboard.configuration.btn_default');
        }
    }

    const renderManualConfigurationSection = (showWelcomeMessage = false) => (
        <div className="dashboard-wrap">
            {showWelcomeMessage && (
                <div className="row mb-3">
                    <div className="col-sm-12">
                        <strong>
                            {t('dashboard.welcome.message')}
                        </strong>
                    </div>
                </div>
            )}
            <div className="row">
                <div className="col-sm-12">
                    <div className="dashboard-box">
                        <div className="accordion" id="manualGLIntegration">
                            <div className="accordion-item bg-white">
                                <h2 className="accordion-header" id="manualGlConfiguation">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                                        <img src={'third-party-coonect.svg'} alt="" /> {t('dashboard.manual.message')}
                                    </button>
                                </h2>
                                <div id="collapseSix" className="collapse show" aria-labelledby="manualGlConfiguation" data-bs-parent="#manualGLIntegration">
                                    <div className="accordion-body">
                                        {renderConfigurationStepper('text-dark p-0')}
                                        
                                            <div className="gl-config-action-row">
                                                <p className="gl-config-helper-text">{t('dashboard.configuration.helper_text')}</p>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary gl-config-action-btn"
                                                    onClick={() => {
                                                        if (_qbdKeyStatus === 'active') {
                                                            // If both COA and Beginning Balance are done, or no active step remains -> skip/finish
                                                            if (isQBDCompleted || !currentConfigurationStep) {
                                                                skipAllSteps();
                                                            } else {
                                                                navigateToConfigurationStep(currentConfigurationStep);
                                                            }
                                                        } else {
                                                            navigateToConfigurationStep(currentConfigurationStep);
                                                        }
                                                    }}
                                                >
                                                    {_qbdKeyStatus === 'active' && isQBDCompleted
                                                        ? t('dashboard.configuration.btn_skip_all', 'Go to Dashboard')
                                                        : getConfigurationButtonLabel()}
                                                </button>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

    const renderSetupMethodSelection = () => (
        <div className="dashboard-wrap">
            <div className="row">
                <div className="col-sm-12">
                    <div className="gl-setup-choice-box">
                        <h3>{t('dashboard.setup_method.title')}</h3>
                        <p className="gl-setup-choice-subtitle">
                            {t('dashboard.setup_method.subtitle')}
                        </p>
                        <div className="gl-setup-choice-grid">
                            <button
                                type="button"
                                className="gl-setup-choice-card"
                                onClick={() => setSelectedSetupMethod('manual')}
                            >
                                <div className="gl-setup-choice-icon" aria-hidden="true">
                                    <img src={'third-party-coonect.svg'} alt="" />
                                </div>
                                <h4>{t('dashboard.setup_method.manual.title')}</h4>
                                <p>{t('dashboard.setup_method.manual.description')}</p>
                                <p className="gl-setup-choice-supporting">{t('dashboard.setup_method.manual.supporting')}</p>
                                <span className="btn btn-primary gl-setup-choice-btn">{t('dashboard.setup_method.manual.btn')}</span>
                            </button>

                            <button
                                type="button"
                                className="gl-setup-choice-card"
                                onClick={() => setSelectedSetupMethod('erp')}
                            >
                                <div className="gl-setup-choice-icon gl-setup-choice-icon-erp" aria-hidden="true">
                                    <img src={'third-party-coonect.svg'} alt="" />
                                </div>
                                <h4>{t('dashboard.setup_method.erp.title')}</h4>
                                <p>{t('dashboard.setup_method.erp.description')}</p>
                                <p className="gl-setup-choice-supporting">{t('dashboard.setup_method.erp.supporting')}</p>
                                <span className="btn btn-primary gl-setup-choice-btn">{t('dashboard.setup_method.erp.btn')}</span>
                            </button>
                        </div>
                        <p className="gl-setup-choice-note">
                            <span>i</span>
                            {t('dashboard.setup_method.note')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )

    if (settingsErrorBranch === branchId) return (
        <div className="container-fluid py-4">
            <Alert variant="danger">{t('dashboard.settings.load_error')}</Alert>
            <button type="button" className="btn btn-primary" onClick={getSettingsData}>
                {t('dashboard.settings.retry')}
            </button>
        </div>
    );
    if (!settingsMatchBranch) return <div role="status" className="spinner-border" />;

    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="page-title pb-3 pt-3">
                    <div className="row align-items-center">
                        <div className="col-sm-12 d-flex align-items-center justify-content-between gap-3">
                            <h1 className="h5 font-weight-700  mb-0">{t('dashboard.title')}</h1>
                            {shouldShowSetupMethodBackButton ? (
                                <button
                                    type="button"
                                    className="btn btn-primary d-flex align-items-center gap-2"
                                    onClick={() => setSelectedSetupMethod(null)}
                                >
                                    <i className="fas fa-arrow-left" aria-hidden="true"></i>
                                    {t('dashboard.back_btn')}
                                </button>
                            ) : <></>}
                        </div>
                    </div>
                </div>

                <BalanceSheetRefreshStatus branchId={branchId} />

                <div className="filter-btn">
                    <div className={`page-loader ${isLoading ? 'visible' : ''}`}>
                        <div className="loader"></div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        {/* {
                            _getOpeningBalanceExistsSettings && (
                                <Alert variant="danger">
                                    <span>
                                        {t('dashboard.upgrade.statement_1')} <strong>{t('dashboard.upgrade_bold')}</strong> {t('dashboard.upgrade.statement_2')}
                                    </span>&nbsp;&nbsp;
                                    <button className='btn btn-sm btn-primary' onClick={() => setConfirmationToLatest(true)}>{t('dashboard.upgrade_btn')}</button>
                                </Alert>
                            ) || <></>
                        } */}
                        {/* {
                            !_getMappedAcc.sales_activity_match && (
                                <Alert variant="danger">
                                    <span>
                                        Any of the POS(s) from your RevRex account is not associated with related GL account. Please go back to your account and assign the associated GL account <strong>before going to Sales GL Classification</strong>.
                                    </span>&nbsp;&nbsp;
                                    <button className='btn btn-sm btn-primary' onClick={() => updateSyncGlModal({ syncSalesAcc: true })}>Sync With RevRex</button>
                                </Alert>
                            ) || <></>
                        } */}
                        {/* {
                            !_getMappedAcc.sales_activity_match && (
                                <Alert variant="danger">
                                    <span>
                                        Any of the POS(s) from your RevRex account is not associated with related GL account. Please go back to your account and assign the associated GL account <strong>before going to Sales GL Classification</strong>.
                                    </span>&nbsp;&nbsp;
                                    <button className='btn btn-sm btn-primary' onClick={() => updateSyncGlModal({ syncSalesAcc: true })}>Sync With RevRex</button>
                                </Alert>
                            ) || <></>
                        } */}
                    </div>
                </div>
                {shouldShowSetupMethodSelection ? renderSetupMethodSelection() : <></>}

                {
                    !shouldShowSetupMethodSelection && ((_getAccountSettings.is_beginning_balance_exists == 1) && (_getAccountSettings.is_coa_modified == 1)) && (_getAccountSettings.transaction_activity_status >= 3) ? (
                        <div className="dashboard-wrap">
                            <div className="row align-items-stretch g-3">
                                {(!isHelper || canViewClassification) && (
                                <div className="col-xl-3 col-lg-6 d-flex">
                                    <div className="dashboard-box w-100 h-100 d-flex flex-column">
                                        <div className="accordion" id="accordionExample1">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingOne">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                        <img src={revenueReconciliationIcon} alt="" /> {t('dashboard.classification')}
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample1">
                                                    <div className="accordion-body">
                                                        <ul>
                                                            {!isHelper || hasPermission(helperPermissions, 'classification', 'deposit_classification') ? (
                                                            <li>
                                                                <Link to={URLS.DEPOSIT_GL_CLASSIFICATION_STATUS}>{t('dashboard.classification.deposit')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'classification', 'expense_classification') ? (
                                                            <li>
                                                                <Link to={URLS.EXPENSE_GL_CLASSIFICATION_STATUS}>{t('dashboard.classification.expense')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'classification', 'revenue_classification') ? (
                                                            <li>
                                                                <Link to={URLS.REVENUE_GL_CLASSIFICATION_STATUS}>{t('dashboard.classification.revenue')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'classification', 'credit_card_classification') ? (
                                                            <li>
                                                                <Link to={URLS.CREDIT_CARD_GL_CLASSIFICATION_STATUS}>{t('dashboard.classification.credit_card')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'classification', 'bank_reconciliation') ? (
                                                            <li>
                                                                <Link to={URLS.BANK_RECONCILE}>{t('dashboard.classification.reconcilation')}</Link>
                                                            </li>
                                                            ) : null}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                )}
                                {(!isHelper || canViewMaintenance) && (
                                <div className="col-xl-3 col-lg-6 d-flex">
                                    <div className="dashboard-box w-100 h-100 d-flex flex-column">
                                        <div className="accordion" id="accordionExample2">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingTwo">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                                        <img src={expenseClassificationIcon} alt="" /> {t('dashboard.maintainance')}
                                                    </button>
                                                </h2>
                                                <div id="collapseTwo" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample2">
                                                    <div className="accordion-body">
                                                        <ul>
                                                            {!isHelper || hasPermission(helperPermissions, 'maintenance', 'manage_chart_of_accounts') ? (
                                                            <li>
                                                                <Link to={URLS.CHARTACCOUNT}>{t('dashboard.maintainance.manage_chart_of_accounts')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'maintenance', 'change_existing_account') ? (
                                                            <li>
                                                                <Link to={'#'} onClick={() => upsertCOA(false)}>{t('dashboard.maintainance.change_existing_account')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'maintenance', 'add_new_account') ? (
                                                            <li>
                                                                <Link to={'#'} onClick={() => upsertCOA(true)}>{t('dashboard.maintainance.add_new_account')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'maintenance', 'transaction_register') ? (
                                                            <li>
                                                                <Link to={URLS.VIEW_REGISTER}>{t('dashboard.maintainance.transaction_register')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'maintenance', 'budget_entry') ? (
                                                            <li>
                                                                <Link to={URLS.BUDGET}>{t('dashboard.maintainance.budget_entry')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'maintenance', 'beginning_balance_entry') ? (
                                                            <li>
                                                                <Link to={URLS.OPENNING_BALANCE}>{t('dashboard.maintainance.beginning_balance_entry')}</Link>
                                                            </li>
                                                            ) : null}

                                                            {!isHelper || hasPermission(helperPermissions, 'maintenance', 'qbo_customers') ? (
                                                            <li>
                                                                <Link to={URLS.QBO_CUSTOMERS}>{t('dashboard.maintainance.qbo_customers')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {/* {
                                                                _getMappedAcc?.sales_activity_count == 0 && (

                                                                    <li>
                                                                        <Link to={URLS.VIEW_REGISTER}>Transaction Register</Link>
                                                                    </li>

                                                                ) || <></>
                                                            }
                                                            <li>
                                                            {
                                                                _getMappedAcc?.sales_activity_count != 0 && (
                                                                    <Link to={URLS.VIEW_REGISTER}>Transaction Register</Link>

                                                                ) || <></>
                                                            }
                                                            </li> */}
                                                            {/* <li>
                                                        <Link to={URLS.REVENUE_GL_CLASSIFICATION}>Sales GL Classification</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={URLS.CREDIT_CARD_GL_CLASSIFICATION}>Credit GL Classification</Link>
                                                    </li> */}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                )}
                                {(!isHelper || canViewForms) && (
                                <div className="col-xl-3 col-lg-6 d-flex">
                                    <div className="dashboard-box w-100 h-100 d-flex flex-column">
                                        <div className="accordion" id="accordionExample3">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingThree">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                                        <img src={exitStrategyIcon} alt="" /> {t('dashboard.forms')}
                                                    </button>
                                                </h2>
                                                <div id="collapseThree" className="accordion-collapse collapse show" aria-labelledby="headingThree" data-bs-parent="#accordionExample3">
                                                    <div className="accordion-body">
                                                        <ul>
                                                              {/* <li>
                                                        <Link to="#">Data Export</Link>
                                                    </li> */}
                                                            {/* {!isHelper || hasPermission(helperPermissions, 'forms', '433b') ? (
                                                            <li>
                                                                <Link to={URLS.FOURTHREETHREEB}>{t('dashboard.forms.433_b')}</Link>
                                                            </li>
                                                            ) : null} */}
                                                            {!isHelper || hasPermission(helperPermissions, 'forms', 'personal_income_statement') ? (
                                                            <li>
                                                                <Link to={URLS.PERSONAL_INCOME_STATMENT}>{t('dashboard.forms.personal_income_statement')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'forms', 'personal_balance_sheet') ? (
                                                            <li>
                                                                <Link to={URLS.PERSONAL_BALANCE_SHEET}>{t('dashboard.forms.personal_balance_sheet')}</Link>
                                                            </li>
                                                            ) : null}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                )}
                                {(!isHelper || canViewReports) && (
                                <div className="col-xl-3 col-lg-6 d-flex">
                                    <div className="dashboard-box w-100 h-100 d-flex flex-column">
                                        <div className="accordion" id="accordionExample4">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingFour">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                                        <img src={reportIcon} alt="" /> {t('dashboard.reports')}
                                                    </button>
                                                </h2>
                                                <div id="collapseFour" className="accordion-collapse collapse show" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <ul>
                                                            {!isHelper || hasPermission(helperPermissions, 'reports', 'bank_transaction_history') ? (
                                                            <li>
                                                                <Link to={URLS.BANK_TRANSACTION}>{t('dashboard.reports.bank_transaction_history')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'reports', 'sales_transaction_history') ? (
                                                            <li>
                                                                <Link to={URLS.SALES_TRANSACTION}>{t('dashboard.reports.sales_transaction_history')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'reports', 'balance_sheet') ? (
                                                            <li>
                                                                <Link to={URLS.BALANCESHEET}>{t('dashboard.reports.balance_sheet')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'reports', 'statement_of_income_loss') ? (
                                                            <li>
                                                                <Link to={URLS.PROFITLOSS}>{t('dashboard.reports.statement_of_income')}</Link>
                                                            </li>
                                                            ) : null}
                                                             {/* <li>
                                                                <Link to={URLS.STATEMENT_OF_CASH_FLOW}>Statement of Cash Flow</Link>
                                                            </li> */}
                                                            {!isHelper || hasPermission(helperPermissions, 'reports', 'business_ratios') ? (
                                                            <li>
                                                                <Link to={URLS.BUSINESS_RATIO}>{t('dashboard.reports.business_ratios')}</Link>
                                                            </li>
                                                            ) : null}
                                                            {!isHelper || hasPermission(helperPermissions, 'reports', 'budget_vs_actual') ? (
                                                            <li>
                                                                <Link to={URLS.BUDGET_VS_ACTUAL}>{t('dashboard.reports.budget_vs_actual')}</Link>
                                                            </li>
                                                            ) : null}
                                                            <li>
                                                                <Link to={URLS.FIVE_YEAR_FORECAST}>{t('dashboard.reports.five_year_forecast')}</Link>
                                                            </li>
                                                            {isERPOptionAvailable && (
                                                            <li>
                                                                <Link to="#" onClick={(event) => { event.preventDefault(); setIsOpenValidationModal(true); }}>
                                                                    QBO Imported data validation
                                                                </Link>
                                                            </li>
                                                            )}
                                                             {/* <li>
                                                                <Link to={URLS.FOURTHREETHREEB}>433-B FORM</Link>
                                                            </li> */}
                                                            {/* <li>
                                                        <Link to="#">Custom Reports</Link>
                                                    </li> */}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )}
                                 {(!isHelper || canViewTaxResolution) && (
                                  <div className="col-xl-3 col-lg-6 d-flex">
                                    <div className="dashboard-box w-100 h-100 d-flex flex-column">
                                        <div className="accordion" id="accordionExample3">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingThree">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                                         <svg xmlns="http://www.w3.org/2000/svg" width="30"height="30"viewBox="0 0 20 20" fill="none" className='mx-2'>
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5855 7.15508C16.5447 7.06675 16.4938 6.98258 16.4222 6.91091L11.4222 1.91091C11.3505 1.83925 11.2663 1.78841 11.178 1.74758C11.153 1.73591 11.1263 1.72925 11.0997 1.72008C11.0297 1.69675 10.958 1.68175 10.8838 1.67758C10.8663 1.67591 10.8505 1.66675 10.833 1.66675H4.99967C4.08051 1.66675 3.33301 2.41425 3.33301 3.33341V16.6667C3.33301 17.5859 4.08051 18.3334 5.00048 18.3334H14.9997C15.9188 18.3334 16.6663 17.5859 16.6663 16.6667V7.50008C16.6663 7.48258 16.6572 7.46675 16.6555 7.44841C16.6513 7.37425 16.6372 7.30258 16.613 7.23258C16.6047 7.20591 16.5972 7.18008 16.5855 7.15508ZM13.8213 6.66675H11.6663V4.51175L13.8213 6.66675ZM4.99967 16.6667V3.33341H9.99967V7.50008C9.99967 7.96091 10.3722 8.33341 10.833 8.33341H14.9997L15.0013 16.6667H4.99967Z" fill="white" />
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.66699 10.0001H13.3337V11.6667H6.66699V10.0001ZM6.66699 13.3334H13.3337V15.0001H6.66699V13.3334ZM6.66699 6.66675H8.33366V8.33341H6.66699V6.66675Z" fill="white" />
                                                        </svg> {t('dashboard.tax_resolution')}
                                                    </button>
                                                </h2>
                                                <div id="collapseFive" className="accordion-collapse collapse show" aria-labelledby="headingThree" data-bs-parent="#accordionExample3">
                                                    <div className="accordion-body">
                                                        <ul>
                                                        {!isHelper || hasPermission(helperPermissions, 'taxResolution', 'form_433A') ?(
                                                         <li>
                                                            <Link className="dropdown-item" to={`${URLS.TAX_RESOLUTION_FORMS}?form=f433a`}>{t('dashboard.tax_resolution.form_433_a')}</Link>
                                                        </li>):null}
                                                        {!isHelper || hasPermission(helperPermissions, 'taxResolution', 'form_433A_OIC') ?(
                                                         <li>
                                                            <Link className="dropdown-item" to={`${URLS.TAX_RESOLUTION_FORMS}?form=f433aoi`}>{t('dashboard.tax_resolution.form_433_aoi')}</Link>
                                                        </li>):null}
                                                        {!isHelper || hasPermission(helperPermissions, 'taxResolution', 'form_433B') ?(
                                                         <li>
                                                            <Link className="dropdown-item"  to={URLS.TAX_FORM_433B}>{t('dashboard.tax_resolution.form_433_b')}</Link>
                                                        </li>):null}
                                                        {!isHelper || hasPermission(helperPermissions, 'taxResolution', 'form_433B_OIC') ?(
                                                         <li>
                                                            <Link className="dropdown-item" to={`${URLS.TAX_RESOLUTION_FORMS}?form=f433boi`}>{t('dashboard.tax_resolution.form_433_boi')}</Link>
                                                        </li>):null}
                                                        {!isHelper || hasPermission(helperPermissions, 'taxResolution', 'form_433D') ?(
                                                         <li>
                                                            <Link className="dropdown-item" to={`${URLS.TAX_RESOLUTION_FORMS}?form=f433d`}>{t('dashboard.tax_resolution.form_433_d')}</Link>
                                                        </li>):null}
                                                        {!isHelper || hasPermission(helperPermissions, 'taxResolution', 'form_433F') ?(
                                                         <li>
                                                            <Link className="dropdown-item" to={`${URLS.TAX_RESOLUTION_FORMS}?form=f433f`}>{t('dashboard.tax_resolution.form_433_f')}</Link>
                                                        </li>):null}
                                                        {!isHelper || hasPermission(helperPermissions, 'taxResolution', 'publication_5059') ?(
                                                         <li>
                                                            <Link className="dropdown-item" to={`${URLS.TAX_RESOLUTION_FORMS}?form=p5059`}>{t('dashboard.tax_resolution.publication_5059')}</Link>
                                                        </li>):null}
                                                        {!isHelper || hasPermission(helperPermissions, 'taxResolution', 'publication_1854') ?(
                                                         <li>
                                                            <Link className="dropdown-item" to={`${URLS.TAX_RESOLUTION_FORMS}?form=p1854`}>{t('dashboard.tax_resolution.publication_1854')}</Link>
                                                        </li>):null}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                )}
                                {/* No helper permission section exists for 1099 yet, so this tile is
                                    visible to subscribers and helpers alike -- matches the header nav. */}
                                <div className="col-xl-3 col-lg-6 d-flex">
                                    <div className="dashboard-box w-100 h-100 d-flex flex-column">
                                        <div className="accordion" id="accordionExample4">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingFour">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className='mx-2'>
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M4.16667 1.66667C3.24619 1.66667 2.5 2.41286 2.5 3.33333V16.6667C2.5 17.5871 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5871 17.5 16.6667V6.66667L12.5 1.66667H4.16667ZM11.6667 3.33333H4.16667V16.6667H15.8333V7.5H12.5C12.0398 7.5 11.6667 7.1269 11.6667 6.66667V3.33333ZM5.83333 10.8333C5.83333 10.3731 6.20643 10 6.66667 10H13.3333C13.7936 10 14.1667 10.3731 14.1667 10.8333C14.1667 11.2936 13.7936 11.6667 13.3333 11.6667H6.66667C6.20643 11.6667 5.83333 11.2936 5.83333 10.8333ZM5.83333 14.1667C5.83333 13.7064 6.20643 13.3333 6.66667 13.3333H10.8333C11.2936 13.3333 11.6667 13.7064 11.6667 14.1667C11.6667 14.6269 11.2936 15 10.8333 15H6.66667C6.20643 15 5.83333 14.6269 5.83333 14.1667Z" fill="white" />
                                                        </svg> {tNav('menu.vendor_center')}
                                                    </button>
                                                </h2>
                                                <div id="collapseSix" className="accordion-collapse collapse show" aria-labelledby="headingFour" data-bs-parent="#accordionExample4">
                                                    <div className="accordion-body">
                                                        <ul>
                                                            <li className="menu-group">{tNav('section.overview')}</li>
                                                            <li>
                                                                <Link className="dropdown-item" to={URLS.TAX_1099_PORTFOLIO}>{tNav('menu.firm_portfolio')}</Link>
                                                            </li>
                                                            <li className="menu-group">{tNav('section.setup')}</li>
                                                            <li>
                                                                <Link className="dropdown-item" to={URLS.TAX_1099_PAYER_SETTINGS}>{tNav('menu.payer_settings')}</Link>
                                                            </li>
                                                            <li className="menu-group">{tNav('section.vendors_payments')}</li>
                                                            <li>
                                                                <Link className="dropdown-item" to={URLS.VENDOR_CENTER}>{tNav('menu.vendor_management')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link className="dropdown-item" to={URLS.TAX_1099_PAYMENTS}>{tNav('menu.payment_ledger')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link className="dropdown-item" to={URLS.TAX_1099_PAYEE_REVIEW}>{tNav('menu.payee_review')}</Link>
                                                            </li>
                                                            <li className="menu-group">{tNav('section.filing')}</li>
                                                            <li>
                                                                <Link className="dropdown-item" to={URLS.TAX_1099_FORMS}>{tNav('menu.forms_1099')}</Link>
                                                            </li>
                                                            <li>
                                                                <Link className="dropdown-item" to={URLS.TAX_1099_YEAR_END_REVIEW}>{tNav('menu.year_end_review')}</Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : !shouldShowSetupMethodSelection && shouldShowManualConfiguration && ((_getAccountSettings.is_beginning_balance_exists == 1) && (_getAccountSettings.is_coa_modified == 1) && ((_getThirdPartyStepsCompleted == 0) || (_getThirdPartyStepsCompleted > 2))) ? (
                        renderManualConfigurationSection()
                    ) : !shouldShowSetupMethodSelection && shouldShowManualConfiguration ? (
                        isManualOptionAvailable ? (
                            renderManualConfigurationSection(true)
                        ) : <></>
                    ) : <></>
                }

                {
                    !shouldShowSetupMethodSelection && shouldShowERPSection ? (
                        <div className="dashboard-wrap mt-3">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="dashboard-box">
                                        <div className="accordion" id="thirdPartyIntegration">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="thirdPartyIntegrationOne">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                                        <img src={'third-party-coonect.svg'} alt="" /> {t('dashboard.third_party_integration.title')}
                                                    </button>
                                                </h2>
                                                <div id="collapseFive" className="collapse show" aria-labelledby="thirdPartyIntegrationOne" data-bs-parent="#thirdPartyIntegration">
                                                    <div className="accordion-body">
                                                        <Link
                                                            to={
                                                                (_getAccountSettings.is_coa_modified === 1) &&
                                                                !_getThirdPartyStepsCompleted
                                                                ? URLS.QUICKBOOK_DASHBOARD
                                                                : URLS.THIRD_PARTY
                                                            }
                                                            className="d-inline-flex align-items-center gap-2 py-2 px-3 bg-primary text-white text-decoration-none fw-semibold rounded"
                                                            style={{ transition: "0.2s ease" }}
                                                            >
                                                            {(_getAccountSettings.is_coa_modified === 1) &&
                                                            !_getThirdPartyStepsCompleted
                                                                ? `▶ ${t('dashboard.third_party_integration.resume')}`
                                                                : `🔗 ${t('dashboard.third_party_integration.available')}`}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : <></>
                }

            </div>

            {
                ((modalSyncGl['syncBankAcc'] || modalSyncGl['syncSalesAcc']) &&
                <RevrexSyncGLAcc syncBankAcc={modalSyncGl['syncBankAcc']} syncSalesAcc={modalSyncGl['syncSalesAcc']} _handleCloseModal={closeSyncModal} />) || <></>
            }

            {
                (showCOAModal && <ChartAccountModal closeModal={hideCOAModal} addRecord={createNewAccount} record={null} />) || <></>
            }
              {/* <SAlert
                msg={`Based on your recent data entry, it appears that you need to upgrade to the latest version of REVREX GL to generate accurate balance sheets and P&L statements. Please click the 'Upgrade to Latest' button before proceeding with other tasks.`}
                show={confirmationToLatest}
                title={t('dashboard.upgrade.confirmation.info')}
                confirmBtnText={t('dashboard.upgrade.confirmation.btn_confirm')}
                cancelBtnText={t('dashboard.upgrade.confirmation.btn_cancel')}
                onConfirm={confirmUpdationToLatest}
                showCancel={true}
                onCancel={() => setConfirmationToLatest(false)}
            /> */}
            <SAlert
                msg={t('dashboard.third_party_integration.qbo_import_instructions')}
                show={showQBOAlert}
                title={t('dashboard.third_party_integration.qbo_import_instructions_title')}
                confirmBtnText={t('dashboard.third_party_integration.qbo_import_instructions_btn')}
                onConfirm={() => {
                    setShowQBOAlert(false)
                    navigate(URLS.BANK_RECONCILE);
                }}
                showCancel={false}
                onCancel={() => setShowQBOAlert(false)}
            />

            <SAlert
                HtmlMsg={t('dashboard.pos_mismatch_closed_month_deposit_sales.message')}
                show={showPosMismatchClosedMonthDepositSalesAlert}
                title={t('dashboard.pos_mismatch_closed_month_deposit_sales.title')}
                confirmBtnText={t('dashboard.pos_mismatch_closed_month_deposit_sales.btn')}
                onConfirm={() => {
                    setShowPosMismatchClosedMonthDepositSalesAlert(false)
                    window.location.href = REVREX_APP_BASE_URL || "";
                    
                }}
                showCancel={false}
                onCancel={() => setShowPosMismatchClosedMonthDepositSalesAlert(false)}
            />

            {
                isOpenValidationModal && branchData &&
                <QBValidationReportModal
                    branchId={+branchData['id']}
                    closeModal={() => setIsOpenValidationModal(false)}
                />
            }

        </div>
    )
}

export default Dashboard;
